import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Filters} from '../../common/filters';
import {fetchListings} from '../../../actions/listings';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import {UNREFINED_KEY} from '../../../utils/listings';
import {wrapInTest} from '../../common/mvt/utils/mvt';
import {TESTS, getValue} from '../../../utils/abacus';
import {LOCATION_TYPES} from '../../../utils/filters';

const MIN_SEGMENTS = 1;

function hasSegments({segments = []}) {
    return segments.length;
}

function isNotBeach(segment) {
    return segment.messageKey !== LOCATION_TYPES.BEACH;
}

function getSegmentsForTest(validSegments, testValue) {
    if (validSegments) {
        return testValue && testValue > 0 ? validSegments : validSegments.filter(isNotBeach);
    }
    return null;
}

function getSegments({destination}) {
    if (!hasSegments(destination)) {
        return null;
    }

    const unrefinedSegment = {
        name: 'Popular',
        messageKey: UNREFINED_KEY
    };

    return destination.segments.length > MIN_SEGMENTS ? [unrefinedSegment, ...destination.segments] : null;
}

export function sendToEdap(refinementKey) {
    const delayProcessing = {delayProcessing: true};
    const mainData = {
        actionlocation: 'properties-module',
        eventrefinements: getRefinements({refinementKey})
    };
    pushEdapEvent('refinement.click', mainData, delayProcessing);
}

export function mapStateToProps(state) {
    const {
        abacus
    } = state;

    const validSegments = getSegments(state);

    const testValue = getValue(abacus, TESTS.SLP_FilterTagRedesign);
    const isTestActive = testValue !== null && testValue >= 0;

    const hasBeachFilter = Array.isArray(validSegments) && validSegments.some(({messageKey}) => messageKey === LOCATION_TYPES.BEACH);
    return {
        abacus,
        fireExposure: hasBeachFilter && isTestActive,
        segments: getSegmentsForTest(validSegments, testValue),
        segmentFilters: state.modules.segmentFilters
    };
}

export class SegmentFiltersComponent extends Component {
    constructor(props) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);

        this.state = {
            activeFilter: UNREFINED_KEY
        };
    }

    clickHandler(segmentKey) {
        this.props.dispatch(fetchListings(segmentKey));
        this.setState({
            activeFilter: segmentKey
        });
        sendToEdap(segmentKey);
    }

    getButtonClasses(isActive) {
        return isActive ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default';
    }

    render() {
        const {
            activeFilter
        } = this.state;

        const {
            segments,
            fireExposure,
            abacus,
            segmentFilters
        } = this.props;

        const testValue = getValue(abacus, TESTS.SLP_FilterTagRedesign);
        if (testValue === 2) {
            return null;
        }

        const button = segments ? (<div>
            <Filters>
                {
                    segments.map((segment) => (
                        <button
                            key={segment.messageKey}
                            className={this.getButtonClasses(activeFilter === segment.messageKey)}
                        onClick={this.clickHandler.bind(null, segment.messageKey)} //eslint-disable-line
                        >{segmentFilters[`${segment.messageKey}`]}
                        </button>
                    ))
                }
            </Filters>
        </div>) : null;

        return fireExposure ? wrapInTest(abacus, TESTS.SLP_FilterTagRedesign, button) : button;
    }
}

export const SegmentFilters = connect(mapStateToProps)(SegmentFiltersComponent);
